import { useMutation } from '@tanstack/react-query';
import { timeOffService } from '../api/time-off.service';

/**
 * Manually opens an entitlement cycle for a member. Owner/Admin only.
 * Omitting `cycleNumber` opens the member's current cycle (unchanged
 * behavior); passing one opens a historical, immediately-`Closed` cycle
 * instead. No cached query invalidation — this module exposes no
 * admin-facing "member balance" read, only the member's own `/me/balance`
 * (not reachable here).
 */
export function useOpenMemberCycle() {
  return useMutation({
    mutationFn: ({ userId, cycleNumber }: { userId: string; cycleNumber?: number }) =>
      timeOffService.openMemberCycle(userId, cycleNumber),
  });
}
